import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form';

import { init } from './estoqueActions';
import LabelAndInput from '../../common/form/labelAndInput';
import LabelAndSelectForm from '../../common/form/labelAndSelectForm';
import Button from '../../common/form/button';

class EstoqueForm extends Component {
  render() {
    const { handleSubmit } = this.props;
    const isUpdate = this.props.isUpdate === true;

    return (
      <form onSubmit={handleSubmit} autoComplete="off" className="simple-cad-form-premium manutencao-cad-premium estoque-cad-premium">
        <div className="simple-cad-premium-container">
          <div className="simple-cad-premium-card">
            <div className="simple-cad-premium-header">
              <h4>
                <i className="fa fa-boxes" /> Item de Estoque
              </h4>
              <p>Materiais e peças utilizados nas ordens de serviço de manutenção.</p>
            </div>
            <div className="simple-cad-premium-body">
              {isUpdate && <Field name="id" component="input" type="hidden" />}
              <Field name="codigo" component={LabelAndInput} label="SKU" cols="12 3" placeholder="Opcional" />
              <Field
                name="descricao"
                component={LabelAndInput}
                label="Descrição"
                cols="12 9"
                placeholder="Ex.: Lâmpada LED semáforo 200mm"
              />
              <Field name="unidade" component={LabelAndInput} label="Unidade" cols="12 3" placeholder="UN, M, KG..." />
              <Field
                name="quantidade_atual"
                component={LabelAndInput}
                type="number"
                step="0.001"
                readOnly={isUpdate}
                label="Quantidade atual"
                cols="12 3"
                placeholder="0"
              />
              <Field
                name="quantidade_minima"
                component={LabelAndInput}
                type="number"
                step="0.001"
                label="Quantidade mínima"
                cols="12 3"
                placeholder="0"
              />
              <Field name="ativo" component={LabelAndSelectForm} label="Situação" cols="12 3">
                <option value="1">Ativo</option>
                <option value="0">Inativo</option>
              </Field>
            </div>
            {isUpdate && (
              <div className="simple-cad-premium-body manutencao-cad-hint">
                <p>
                  <i className="fa fa-info-circle" /> A quantidade atual é alterada apenas pela aba{' '}
                  <strong>Movimentar</strong> (entradas, saídas e devoluções).
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="simple-cad-premium-footer">
          <Button type="submit" className={this.props.submitClass} icon="check" label={this.props.submitLabel} />
          <Button type="button" className="default" icon="close" label="Cancelar" onClick={this.props.init} />
        </div>
      </form>
    );
  }
}

EstoqueForm = reduxForm({ form: 'estoqueForm', destroyOnUnmount: false })(EstoqueForm);
const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch);
export default connect(null, mapDispatchToProps)(EstoqueForm);
